<!-- LOADER -->
@if (themeClass()) {
	<div [class]="'theme-wrapper ' + themeClass()">
		@if (showCrossFade()) {
			<div class="crossFadeCon">
				<div class="crossfade">
					<figure></figure>
					<figure></figure>
					<figure></figure>
					<figure></figure>
					<figure></figure>
					<figure></figure>
				</div>
			</div>
		}

		<!--SIDENAV-->
		<mat-sidenav-container>
			<mat-sidenav
				#sidenav
				[autoFocus]="false"
				[class.isTwoScreen]="isTwoScreen()"
				mode="over"
			>
				<sim-header-sidenav
					(openUserCard)="openUserCard()"
					[user]="userService.user"
					class="sideNavHeader"
				/>
				<sim-side-navigation-menu
					[navigationMenuOpened]="sidenav.openedStart"
					(closeSidenavEmitter)="sidenav.close()"
				/>
			</mat-sidenav>

			@if (showNav()) {
				<sim-header-toolbar
					(timeUp)="showSystemWarning.set(false)"
					(cancelShutdown)="cancelSystemShutdown()"
					[showSystemWarning]="showSystemWarning()"
					[showBurgerMenu]="showBurgerMenu()"
					[sidenav]="sidenav"
					[nextSystemShutdown]="nextSystemShutdownInSeconds()"
				/>
			}

			<router-outlet />
		</mat-sidenav-container>
	</div>
}

<sim-system-actions />
